import React from 'react'
import Navigation from './Navigation'
import Toast from './Toast'

const Main = props => {
  return (
    <>
      <Toast />
      <Navigation />
      {props.children}
    </>
  )
}

export default Main
